import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/outline';

const PaymentMethods = () => {
  return (
    <div className='p-6 border-b border-slate-200'>
      <h2 className='text-lg font-semibold text-slate-900 mb-4'>Métodos de pago disponibles</h2>
      <div className='grid grid-cols-2 gap-4'>
        <div className='flex items-center p-4 bg-slate-50 rounded-lg'>
          <CheckCircleIcon className='w-5 h-5 text-green-500 mr-3' />
          <span className='text-slate-700'>Tarjeta de crédito/débito</span>
        </div>
        <div className='flex items-center p-4 bg-slate-50 rounded-lg'>
          <CheckCircleIcon className='w-5 h-5 text-green-500 mr-3' />
          <span className='text-slate-700'>Transferencia bancaria</span>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethods;
